import themeConfig from '../../../../themeConfig';

/**
 * Common charts and analytics data and functionalities
 *
 * @module views/charts-and-maps/charts/commonChartsAndAnalytics
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 */
export default {
  props: {
    fetchDataFunction: {
      type: Function,
    },
    seriesData: {
      type: Object,
    },
    seriesInfo: {
      type: Array,
      required: true,
      validator(seriesInfo) {
        return seriesInfo.every(
          (s) => typeof s === 'object'
            && 'name' in s
            && 'key' in s
            && 'color' in s,
        );
      },
    },
    noDataTitle: {
      type: String,
      required: true,
    },
    noDataSubtitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      commonChartsNoDataOptions: {
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        title: {
          text: '',
          align: 'center',
          offsetY: 150,
          floating: true,
          style: {
            fontSize: '1.3rem',
            color: themeConfig.colors.content,
          },
        },
        subtitle: {
          text: '',
          align: 'center',
          offsetY: 180,
          floating: true,
          style: {
            fontSize: '1rem',
            color: themeConfig.colors.content,
          },
        },
        colors: [
          themeConfig.colors['grey-light'],
        ],
        tooltip: {
          enabled: false,
        },
      },
      chartAnalyticsData: null,
      chartKey: 0,
    };
  },
  watch: {
    chartOptions() {
      this.chartKey += 1;
    },
    chartAnalyticsData(data) {
      this.$emit('chart-data', data);
    },
  },
};
